// extracted by mini-css-extract-plugin
var _1 = "ArtWork-u534k";
var _2 = "Placeholder-IdN78";
var _3 = "fadeIn-WDy2P";
export { _1 as "ArtWork", _2 as "Placeholder", _3 as "fadeIn" }
